import type { ComponentStyleConfig } from "@chakra-ui/react";

export const FormLabelTheme: ComponentStyleConfig = {
  baseStyle: {
    fontSize: "sm",
    p: 0,
    m: 0,
  },
  variants: {
    underline: {
      color: "black",
      fontWeight: "regular",
      cursor: "pointer",
      "> span": {
        filter: "none",
      },
      _hover: {
        color: "brand.red.100",
        textDecoration: "underline",
        boxShadow: 0,
      },
    },
  },
};
